import { PERSIST_REDUX_KEYS } from "../actionTypes";

const initialState = {
    selectedRoute: null,
    getAppSyncDetailsByTenant: null,
    BzDynamicMenu: null,
    TermsCondition: null,
    AboutUs: null,
    Disclaimer: null,
    exchangeTime: null,
    brokerinformation: null,
    indicesData: null,
    worldIndicesData: null,
};

const loginReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_WORLD_INDICES_DATA:
            return {
                ...state,
                worldIndicesData: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_INDICES_DATA:
            return {
                ...state,
                indicesData: actions?.payload
            };
        case PERSIST_REDUX_KEYS.SELECTED_ROUTE:
            return {
                ...state,
                selectedRoute: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_APP_INFO:
            return {
                ...state,
                getAppSyncDetailsByTenant: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_TERMS_COND:
            return {
                ...state,
                TermsCondition: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_ABOUT_US:
            return {
                ...state,
                AboutUs: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_BZ_DYNAMIC:
            return {
                ...state,
                BzDynamicMenu: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_DISCLAIMER:
            return {
                ...state,
                Disclaimer: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_EXCHANGE_TIME:
            return {
                ...state,
                exchangeTime: actions?.payload
            };
        case PERSIST_REDUX_KEYS.UPDATE_PERSIST_BROKER_INFO:
            return {
                ...state,
                brokerinformation: actions?.payload
            };
        default:
            return state;
    }
};
export default loginReducer;